module.exports = __webpack_public_path__ + "teqbahn-assets/media/tilli_bw_new.214a3595.png";